import lodash from 'src/utils/lodash'

export const isString = lodash.isString
